import request, {requestJson} from '../main';
import {ejianUrl} from "@/constants";
const service = ""
class InstrumentApi {
    private url: string = service + "/instrument";
    //器具列表
    public list(params: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: params
        })
    }
    //器具添加和更新
    public update(params: any){
        return requestJson({
            url: this.url + '/update',
            method: 'post',
            data: params
        })
    }
    //器具添加和更新
    public ejianUpdateInstrumentNotLogin(params: any){
        return requestJson({
            url: ejianUrl + '/detect' + this.url + '/update-instrument-not-login',
            method: 'post',
            data: params
        })
    }
    //器具删除
    public delete(params: any){
        return request({
            url: this.url + '/delete',
            method: 'post',
            data: params
        })
    }
    //器具查详情
    public getById(params: any){
        return request({
            url: this.url + '/get-by-id',
            method: 'get',
            params: params
        })
    }
    //器具查详情
    public ejianGetDetail(params: any){
        return request({
            url: ejianUrl + '/detect' + this.url + '/get-detail-not-login',
            method: 'get',
            params: params
        })
    }

    //器具详情接口
    public getDetailById(params: any){
        return request({
            url: this.url + '/get-detail-by-id',
            method: 'get',
            params: params
        });
    }

    //根据id获取审核详情
    public getAuditDetails(params: any){
        return request({
            url: this.url + '/get-audit-details',
            method: 'get',
            params: params
        })
    }

    public getValidSymbols(params: any){
        return request({
            url: this.url + '/get-valid-symbols',
            method: 'get',
            params: params
        })
    }
    public listInstrumentRegionNum(params: any){
        return request({
            url: this.url + '/list-instrument-region-num',
            method: 'get',
            params: params
        })
    }

    public listInstrumentMechanism(params: any){
        return request({
            url: this.url + '/list-instrument-mechanism',
            method: 'get',
            params: params
        })
    }

    //批量导入器具
    public importInstruments(params: any){
        return requestJson({
            url: this.url + '/import-instruments',
            method: 'post',
            data: params
        })
    }
    public listMyMechanismInstrument(params: any){
        return request({
            url: this.url + '/list-my-mechanism-instrument',
            method: 'get',
            params: params
        })
    }

    public ejianListMyMechanismInstrument(params: any){
        return request({
            url: ejianUrl + '/detect' + this.url + '/list-my-mechanism-instrument',
            method: 'get',
            params: params
        })
    }

    public checkProgress(id: number){
        return request({
            url: this.url + '/check-progress',
            method: 'get',
            params: {
                instrId: id
            }
        })
    }



}

class NewInstrumentApi {
    private url: string = service + "/new-instr";

    //器具查详情
    public getDetail(id: any){
        return request({
            url: this.url + '/get-detail',
            method: 'get',
            params: {
                id: id
            }
        })
    }

    //器具查详情
    public listMyMechanismInstrument(ownerId: any){
        return request({
            url: this.url + '/list-my-mechanism-instrument',
            method: 'get',
            params: {
                ownerId: ownerId
            }
        })
    }


    public updateInstrumentNotLogin(args: any){
        return requestJson({
            url: this.url + '/update-instrument',
            method: 'post',
            data: args
        })
    }

}
const instrumentApi = new InstrumentApi();
const newInstrumentApi = new NewInstrumentApi();
export {instrumentApi, newInstrumentApi}
